import React from 'react';
import Button from '../button/index';
import cx from 'classnames';
var clsPrefix = 'tcpc-discounts-menu';

var MenuItem = function MenuItem(props) {
  var style = props.style,
      className = props.className,
      user = props.user,
      saleDate = props.saleDate,
      details = props.details,
      region = props.region,
      salePrice = props.salePrice,
      discountPrice = props.discountPrice,
      onClick = props.onClick;
  var baseProps = {
    style: style,
    className: cx(clsPrefix, className)
  };
  return /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-header")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-user")
  }, user), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-time")
  }, saleDate, " ", /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-region")
  }, region))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-main")
  }, Array.isArray(details) && details.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-item"),
      key: item.label
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-label")
    }, item.label), /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-content")
    }, item.content));
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-footer")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-left")
  }, "\u6210\u4EA4\u50F9", /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-price-label")
  }, salePrice), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-right")
  }, "\u512A\u60E0\u79AE\u5305", /*#__PURE__*/React.createElement("i", {
    className: "".concat(clsPrefix, "-down-icon")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-down-price")
  }, discountPrice))), /*#__PURE__*/React.createElement(Button, {
    className: "".concat(clsPrefix, "-gift-btn"),
    inline: true,
    radius: true,
    type: "warning",
    size: "large",
    onClick: onClick
  }, "\u8A62\u6210\u4EA4\u50F9")));
};

export default MenuItem;